var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 338,
    viewBox: "0 0 600 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M600 0H0V337.5H600V0Z",
    fill: "#065ABF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M239.1 336.8L517.9 -11.7L818 280.5L812.8 312.7L736 417.5L238 337.9L239.1 336.8Z",
    fill: "#48C0B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M630.3 349.4C669.623 349.4 701.5 324.238 701.5 293.2C701.5 262.162 669.623 237 630.3 237C590.977 237 559.1 262.162 559.1 293.2C559.1 324.238 590.977 349.4 630.3 349.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M301.1 64.3C317.669 64.3 331.1 58.614 331.1 51.6C331.1 44.586 317.669 38.9 301.1 38.9C284.531 38.9 271.1 44.586 271.1 51.6C271.1 58.614 284.531 64.3 301.1 64.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M569.5 271.3C606.282 271.3 636.1 241.482 636.1 204.7C636.1 167.918 606.282 138.1 569.5 138.1C532.718 138.1 502.9 167.918 502.9 204.7C502.9 241.482 532.718 271.3 569.5 271.3Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M283.8 57.0001C297.718 57.0001 309 45.7177 309 31.8001C309 17.8825 297.718 6.6001 283.8 6.6001C269.882 6.6001 258.6 17.8825 258.6 31.8001C258.6 45.7177 269.882 57.0001 283.8 57.0001Z",
    fill: "#00DFFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 337.5,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card-1.01be328d37848d0a13a4d57e4b5118df.svg";
export { ForwardRef as ReactComponent };